import { apiClient } from './api'

export interface WeatherCurrent {
  dt: number
  temp: number
  feels_like: number
  pressure: number
  humidity: number
  dew_point: number
  uvi: number
  clouds: number
  visibility: number
  wind_speed: number
  wind_deg: number
  wind_gust?: number
  weather: {
    id: number
    main: string
    description: string
    icon: string
  }[]
}

export interface WeatherDaily {
  dt: number
  temp: {
    day: number
    min: number
    max: number
    night: number
    eve: number
    morn: number
  }
  feels_like: {
    day: number
    night: number
    eve: number
    morn: number
  }
  pressure: number
  humidity: number
  dew_point: number
  wind_speed: number
  wind_deg: number
  wind_gust?: number
  weather: {
    id: number
    main: string
    description: string
    icon: string
  }[]
  clouds: number
  pop: number
  rain?: number
  snow?: number
  uvi: number
}

export interface CurrentWeatherResponse {
  lat: number
  lon: number
  timezone: string
  timezone_offset: number
  current: WeatherCurrent
}

export interface ForecastWeatherResponse {
  lat: number
  lon: number
  timezone: string
  timezone_offset: number
  daily: WeatherDaily[]
}

export const weatherService = {
  getCurrentWeather: async (accountId: string): Promise<CurrentWeatherResponse> => {
    const { data } = await apiClient.get(`/weather/${accountId}/current`)
    return data
  },

  getForecast: async (accountId: string): Promise<ForecastWeatherResponse> => {
    const { data } = await apiClient.get(`/weather/${accountId}/forecast`)
    return data
  }
}
